/** Resolve existing listing delivery flags, preserving evidence-based legacy shipping. */
const getDeliveryMethods = (publicData = {}) => {
  const explicitFlags =
    typeof publicData.shippingEnabled === 'boolean' ||
    typeof publicData.pickupEnabled === 'boolean';
  const legacyShipping =
    !explicitFlags &&
    (!!publicData.shippingDetails || Number.isInteger(publicData.shippingPriceInSubunitsOneItem));
  return publicData.shippingEnabled === true || legacyShipping ? ['shipping'] : [];
};

/** Identify historical listings that require seller migration before purchase. */
const requiresShippingMigration = (publicData = {}) =>
  publicData.pickupEnabled === true && !getDeliveryMethods(publicData).includes('shipping');

module.exports = { getDeliveryMethods, requiresShippingMigration };
